// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSystemList } from "@ces/App/Services/SystemListService";
import { generatePickUpTimes } from "@ces/XDL/Utilities";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";

export interface StartEndTime {
    start?: string;
    end?: string;
}
type HandlerType = ApiHandler<
    { warehouseOpenTime?: string; warehouseCloseTime?: string },
    { availableTimes: string[]; startEndTime: StartEndTime }
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        warehouseOpenTime: props.parameter.warehouseOpenTime,
        warehouseCloseTime: props.parameter.warehouseCloseTime,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        const { warehouseOpenTime, warehouseCloseTime } = props.apiParameter;
        if (warehouseOpenTime && warehouseCloseTime) {
            props.apiResult = generatePickUpTimes(warehouseOpenTime, warehouseCloseTime);
        } else {
            const result: any = await getSystemList({ systemListName: "DefaultRequestedPickupTimes" });
            const timesArray = result.values.map((item: any) => item.name);
            props.apiResult = {
                availableTimes: timesArray,
                startEndTime: { start: timesArray[0], end: timesArray[timesArray.length - 1] },
            };
        }
    } catch (error) {
        logger.error(error);
    }
};

export const DispatchCompleteLoadAccountThumbnailsData: HandlerType = props => {
    props.dispatch({
        type: "xRequestedPickupTimes/CompleteLoadPickupTimes",
        result: props.apiResult,
    } as any);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadAccountThumbnailsData];

const requestedPickupTimes = createHandlerChainRunner(chain, "requestedPickupTimes");

export default requestedPickupTimes;
